import VodyanoyApp from "./VodyanoyApp";
const tasks = [
  { A: 3, B: 2, win: 1 },
  { A: 9, B: 2, win: 1 },
  { A: 5, B: 3, win: 1 },
  { A: 5, B: 3, win: 4 },
  { A: 7, B: 5, win: 1 },
  { A: 8, B: 5, win: 1 },
  { A: 8, B: 5, win: 4 },
  { A: 8, B: 5, win: 7 },
  { A: 11, B: 4, win: 1 },
  { A: 35, B: 15, win: 10 },
  { A: 10, B: 3, win: 8 },
  { A: 9, B: 5, win: 3 },
  { A: 9, B: 4, win: 6 },
  { A: 9, B: 4, win: 3 },
  { A: 9, B: 5, win: 8 },
  
];
const vodyanoyRoutes = tasks.flatMap((task) => [
  {
    path: `/vodyanoy/ball/${task.A}/${task.B}/${task.win}`,
    element: (
      <VodyanoyApp
        GameType="ball"
        VolumeA={task.A}
        VolumeB={task.B}
        WinVolume={task.win}
      />
    ),
  },
  {
    path: `/vodyanoy/beaker/${task.A}/${task.B}/${task.win}`,
    element: (
      <VodyanoyApp
        GameType="beaker"
        VolumeA={task.A}
        VolumeB={task.B}
        WinVolume={task.win}
      />
    ),
  },
]);
export default vodyanoyRoutes;